import React from 'react';
import TopNav from '../../../../components/TopNav/TopNav';

interface ProfileProps {
  showScannedFace: boolean;
  scannedFaceDoc: string;
  backClick: () => void;
  id: string | undefined;
}

const Profile: React.FC<ProfileProps> = ({
  showScannedFace,
  scannedFaceDoc,
  backClick,
  id,
}) => {
  if (!showScannedFace) return null; // If the flag is false, don't render anything

  return (
    <>
      <TopNav
        showArrow={true}
        backRoute={`/supervisor/participantDetails/${id}`}
        backClick={backClick}
      />
      <img
        src={scannedFaceDoc}
        style={{
          height: '80vh',
          width: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto',
          objectFit: 'cover',
        }}
        alt="profile"
      />
    </>
  );
};

export default Profile;
